<template>
  <div class="study2022-5-26">

    <JumpTemplate
      v-if="listItem && listItem.id && iframeUrl"
      v-model="iframeUrl"
      :childrenIframeUrl="childrenIframeUrl"
      :activeOne="listItem"
      :optObject="optObject"
      :platformName="buttonShowArr"
      :isBtn="isBtn"
      :type="type"
      ref="JumpTemplate"
      :catalogId="catalogId"
      :templateCode="templateCode"
      :myStation="myStation"
      @insertDirectory="insertDirectory"
      @nextQuestion="nextQuestion"
      :isMyStatus="isMy"
    ></JumpTemplate>

    <div class="course_content" v-loading="vloading">
      <div class="course_left">
        <div class="study_zonghe">
          <div class="right">
            <p><span>学习进度</span><span>{{ percentage>100?100:Math.ceil(percentage) }}%</span></p>
            <div class="study_progress_box">
              <el-progress
                color="#215DE8"
                :show-text="false"
                :stroke-width="16"
                :percentage="percentage>100?100:Math.ceil(percentage)"
                class="circle_progress">
              </el-progress>
            </div>
          </div>
          <div class="left">
            <p>我的岗位</p>
              <ul v-if="myStation.length" class="station">
                <li v-for="(item,index) in myStation" :key="index" :title="item.name">{{item.name}}</li>
              </ul>
              <ul v-else class="noStation">
                <li>暂无岗位</li>
              </ul>
          </div>
        </div>
        <!--        <div class="course_tree" :style="'height:'+ treeHeight">-->
        <div class="course_tree">
          <ul class="status_box">
            <div class="status_left">
              <li>
                <i></i>
                <span>已完成</span>
              </li>
              <!-- <li>
                <i></i>
                <span>进行中</span>
              </li> -->
              <li>
                <i></i>
                <span>未完成</span>
              </li>

            </div>
            <div class="status_right" v-if="myStation.length && catalogId && swiperData.length">
              <el-switch
                v-model="isMy"
                @change="changeMy"
                active-text="我的"
                active-color="#215DE8"
                inactive-color="#DCDFE6">
              </el-switch>

            </div>
            <div class="work_list" @click="handleWork">
                任务列表
              </div>
          </ul>
          <el-collapse v-model="catalogId" accordion @change="changeCollapse" >
            <el-collapse-item class="collapse_item" v-for="(item,index) in catalogData" :key="index" :name="item.id" :disabled="(userType==2||userType==3)?(!item.status || item.lockStatus==1):(item.lockStatus==1)">
              <template slot="title">
                <span class="title_cont" :title="item.catalogName">{{ item.catalogName }}</span>
                <template v-if="userType==2||userType==3">
                  <span v-if="!item.status || item.lockStatus==1" class="is_finish"><i class='el-icon-lock'></i></span>
                </template>
                <template v-if="userType==0||userType==1">
                  <span v-if="item.lockStatus==1" class="is_finish"><i class='el-icon-lock'></i></span>
                </template>
              </template>
              <div class="cont" v-if="swiperData.length">
                <!-- 任务 -->
                <div :class="swiperData.filter(item=>item.resourceType == 1).length?'task':'tasks'" v-if="swiperData.filter(item=>item.resourceType == 3).length">
                  <p><span>任务</span><span>{{swiperData.filter(item=>item.isFinish == 1).length}}/{{ swiperData.filter(item=>item.resourceType == 3).length }}</span></p>
                  <ul>
                    <li :class="k.isFinish == 1 && activeIndex == j?'isFinishActive':(k.isFinish != 1 && activeIndex == j?'active':(k.isFinish == 1 && activeIndex != j)?'isFinish':'')" v-for="(k,j) in swiperData.filter(item=>item.resourceType == 3)" :key="j" @click="tabsTask(k,j,'1')">
                      {{ j+1 }}
                      <!-- {{ k.isFinish }} -->
                      <!-- {{ activeIndex == j }} -->
                    </li>
                  </ul>
                </div>
                <!-- 资料 -->
                <div class="material" v-if="swiperData.filter(item=>item.resourceType == 1).length">
                  <p><span>资料</span></p>
                  <ul>
                    <li :class="materialId == i?'active':''" v-for="(v,i) in swiperData.filter(item=>item.resourceType == 1)" :key="i" @click="tabsMaterial(v,i,'1')">{{ i+1 }}</li>
                  </ul>
                </div>
              </div>
              <!-- <div class="noCont" v-else>暂无内容</div> -->
            </el-collapse-item>
          </el-collapse>
          <!-- <el-tree
            :data="catalogData"
            :props="defaultProps"
            node-key="id"
            accordion
            :default-expanded-keys=expendId
            :highlight-current="true"
            @node-click="handleNodeClick"
            ref="vuetree"
          >
            <div slot-scope="{ node, data }">
              <span class="span-ellipsis" :title="node.label">{{ node.label }}</span>
              <template v-if="userType==2||userType==3">
                <span v-if="!data.status || data.lockStatus==1" class="is_finish"><i class='el-icon-lock'></i></span>
              </template>
              <template v-if="userType==0||userType==1">
                <span v-if="data.lockStatus==1" class="is_finish"><i class='el-icon-lock'></i></span>
              </template>
            </div>
          </el-tree> -->
        </div>
      </div>
      <div v-if="statusFlag && !statusLoading" class="course_main" v-loading="loading">
        <!-- <miniSwiper v-if="!swiperFlag && type != 3" @getActiveIndex="getActiveIndex"></miniSwiper> -->
        <div v-if="listItem && Object.keys(listItem).length" class="show_main" :style="'height: '+(((type==3 || type==7)||((type==2||type==1)&&swiperFlag)) ? windowHeight-88 : windowHeight-120)+'px'">
          <h2 class="title">
            <span class="task_name" v-if="listItem.testPaper === null">{{listItem.resourceType === 3 ? "试题" : listItem.name}}</span>
            <span class="task_name" v-else>
              {{listItem.resourceType === 3 ?
              "试题" :  listItem.testPaper?listItem.name+"("+listItem.testPaper.paperScore+"分"+"/"+listItem.testPaper.count+"题"+")": ''}}
            </span>
            <span class="task_name" v-if="startTest === 'answerDetail'" style="margin-left: 25px;">{{listItem.resourceType === 3 ? "" : "得分 ："}}</span>
            <span class="task_name" v-if="startTest === 'answerDetail'" style="color:red;">{{listItem.resourceType === 3 ? "" : score}}</span>
            <button v-if="listItem && listItem.downloadFlag==1&&listItem.resourceType==1" @click="download(listItem.id)">下 载
            </button>
            <div
              v-if="listItem.resourceType===3 && (userType==0||userType==1) && courseType == '3'"
              class="is_view_answers">
              <el-switch
                v-model="listItem.show"
                @change="changeSwitch"
                active-color="#215DE8"
                inactive-color="#DCDFE6">
              </el-switch>
              <span style="padding-left: 3px;">允许查看答案</span>
            </div>
          </h2>
          <!-- 图片 -->
          <div v-if="listItem.type ==1" class="img_wrap">
            <div :style="{transform:'scale(1)',transformOrigin:'top left'}">
              <viewer :images="[listItem.newAttaUrl]">
                <img v-for="(src,i) in [listItem.newAttaUrl]" :src="src" :key="i">
              </viewer>
            </div>
          </div>
          <!-- 文档 pdf等-->
          <div :class="'pdf_wrap '+pdfEnlargStyle+' '+pageStyle" @dblclick="pdfdblclick" v-if="listItem.type ==2 && listItem.typeSuffix != 'xls' && listItem.typeSuffix != 'xlsx'">
            <pdf
              style="width: 99%;margin:auto;"
              ref="pdf"
              :src="listItem.newAttaUrl"
              :page="pageNum"
              :rotate="pageRotate"
              @progress="loadedRatio = $event"
              @num-pages="pageTotalNum=$event"
              @link-clicked="page = $event"
              @loaded="loadPdfHandler"
            >
            </pdf>
            <i class="el-icon-arrow-left btn-def btn-pre" @dblclick.stop="" @click.stop="prePage"></i>
            <i class="el-icon-arrow-right btn-def btn-next" @dblclick.stop="" @click.stop="nextPage"></i>
            <span class="pdfCurrentPage">{{pageNum}}/{{pageTotalNum}}</span>
            <div class="operating_btn">
              <div>
                <i class="el-icon-refresh-left" @click="counterClock" @dblclick.stop=""></i>
                <i class="el-icon-refresh-right" @click="clock" @dblclick.stop=""></i>
              </div>
            </div>
          </div>
          <!-- 文档 xls、xlsx-->
          <div :class="'pdf_wrap '+pdfEnlargStyle+' '+pageStyle" @dblclick="pdfdblclick" v-if="listItem.type ==2 && (listItem.typeSuffix == 'xls' || listItem.typeSuffix == 'xlsx')">
            <!-- :src="'https://view.xdocin.com/view?src=' + listItem.originalAttaUrl" -->
            <iframe
              :src="`${ envPreview }${listItem.originalAttaUrl || listItem.newAttaUrl}`"
              frameborder="0"
              width="100%"
              height="98%"
            ></iframe>
          </div>
          <!-- 音频 -->
          <audio
            :src="listItem.newAttaUrl"
            controls="controls"
            v-if="listItem.type ==3"
            ref="audioC"
          ></audio>
          <!-- 视频 -->
          <video
            v-if="listItem.type ==4"
            id="video1"
            class="video-js"
            controls
            controlsList="nodownload"
            preload="auto"
            @play="videoPlay"
            @ended="endVideo"
            width="100%"
            :style="'height:'+videoHeight"
            data-setup='{"example_option":true}'
            ref="videoC"
          >
            <source
              id="sourceBox"
              :src="listItem.newAttaUrl"
              type="video/mp4"
            />
            <p class="vjs-no-js">不支持播放</p>
          </video>
          <!-- zip -->
          <div v-if="listItem.type == 5" class="zip_wrap">
            <iframe
              width="100%"
              height="100%"
              :src="listItem.newAttaUrl"
              frameborder="0"
              v-if="isZip"
            ></iframe>
            <div v-if="!isZip&&listItem.downloadFlag==1">
              <p>请点击“下载”，下载 “{{listItem.name}}” 到本地。</p>
            </div>
          </div>
          <!-- 试题 -->
          <div v-if="listItem.resourceType == 3" class="zip_wrap">
            <div class=" editorShowArea ql-editor" v-html="listItem.content"></div>
            <div class="btn_wrap" v-if="listItem.resourceType == 3">

              <platform-btn
                v-if="rolesStatus === 0 "
                :type="type"
                :courseId="courseId"
                :classId="classId"
                :catalogId="catalogId"
                :listItem="listItem"
                :myStation="myStation"
                :buttonShowArr="buttonShowArr"
                ref="platformBtn"
                @platformJump="platformJump">
              </platform-btn>

              <span style="color: #E6A23C;" v-else-if="rolesStatus === 1">此业务非“我的”职责任务</span>
              <span style="color: #E6A23C" v-else-if="rolesStatus === 2">该任务无需作答</span>
            </div>
          </div>
          <!-- 试卷 -->
          <div v-if="listItem.resourceType == 5" class="test_wrap">
            <ul>
              <li v-for="(item,key) in listItem.testPaper.sections" :key="key">
                <h3>{{item.sectionAlias ||  item.sectionName}}</h3>
                <p>{{item.sectionScore}}分 / {{item.questionCount}}题</p>
                <img v-if="item.sectionName=='单选题'" src="../../../../../../static/images/study/radio.png"/>
                <img v-if="item.sectionName=='多选题'" src="../../../../../../static/images/study/checkbox.png"/>
                <img v-if="item.sectionName=='判断题'" src="../../../../../../static/images/study/judge.png"/>
                <img v-if="item.sectionName=='实操题'" src="../../../../../../static/images/study/operation.png"/>
              </li>
            </ul>
            <div class="startPractice_box">
              <div v-bury="{start: true}" @click="intoStuPreview(listItem)" v-if="startTest === 'answerDetail'"
                   class="startPractice">作答详情
              </div>
              <div v-bury="{start: true}" @click="intoStuPreview(listItem)" v-if="startTest1 === 'answerDetail'"
                   class="startPractice">作答详情
              </div>
              <div v-bury="{start: true}" @click="beginTest(listItem)" v-if="startTest === 'startQuestion'"
                   class="startPractice">开始作答
              </div>
              <div v-bury="{start: true}" @click="beginTest(listItem)" v-if="startTest === 'continueQuestion'"
                   class="startPractice">继续作答
              </div>
              <div v-bury="{start: true}" @click="beginTest(listItem,1)" v-if="startTest1 ==='againQuestion'"
                   class="startPractice">重做一遍
              </div>
              <div v-bury="{start: true}" @click="intoPreview(listItem)" v-if="startTest === 'enter'"
                   class="startPractice">进入测验
              </div>
            </div>
          </div>
          <!-- 小工具 -->
          <!--          <div id="note">-->
          <!--            <div class="feed_back btn" @click="showFeedBack">-->
          <!--              <div class="imgBox"><img src="../../img/feedBack.png"/></div>-->
          <!--              <span>意见反馈</span>-->
          <!--            </div>-->
          <!--            <div class="note_btn btn" @click="showNote">-->
          <!--              <div class="imgBox"><img src="../../../../../../static/images/study/icon/biji.png"/></div>-->
          <!--              <span>{{noteText}}</span>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div v-else class="show_main_null">
          <img src="../../../../../../static/images/wujieguo.png"/>
          <p>本节无内容，请选择其他章节</p>
        </div>
      </div>
      <div class="lock_box" v-else v-loading="statusLoading">
        <img src="../../../../../../static/images/wujieguo.png"/>
        <p v-if="!statusLoading">该章节暂未开放</p>
      </div>
      <!-- <div v-if="(type == '3' && listItem && statusFlag && !statusLoading) ? showFlag : swiperFlag" class="course_right">
        <mySwiper v-if="isShowRight" :type="type" @getActiveIndex="getActiveIndex" :catalogId="catalogId" ref="myswiper"></mySwiper>
      </div> -->
      <div v-if="isShowNote" class="course_right">
        <Note v-if="isShowNote"></Note>
      </div>


    </div>
    <el-dialog class="work_list_dialog" title="任务列表" :modal-append-to-body="false" :close-on-click-modal="false" :visible.sync="workListDialogVisible" width="640px">
      <div style="height: 500px;;overflow-y: auto">
        <el-collapse v-model="workCatalogId" accordion  @change="changeWorkCollapse" >
            <el-collapse-item class="collapse_item_work" v-for="(item,index) in catalogData" :key="index" :name="item.id" :disabled="(userType==2||userType==3)?(!item.status || item.lockStatus==1):(item.lockStatus==1)">
              <template slot="title">
                <span class="title_cont_work" :title="item.catalogName">{{ item.catalogName }}</span>
                <template v-if="userType==2||userType==3">
                  <span v-if="!item.status || item.lockStatus==1" class="is_finish_work"><i class='el-icon-lock'></i></span>
                </template>
                <template v-if="userType==0||userType==1">
                  <span v-if="item.lockStatus==1" class="is_finish_work"><i class='el-icon-lock'></i></span>
                </template>
              </template>
              <div class="cont_work" v-if="swiperData.length">
                <!-- 任务 -->
                <div :class="swiperData.filter(item=>item.resourceType == 1).length?'task':'tasks'" v-if="swiperData.filter(item=>item.resourceType == 3).length">
                  <p><span>任务</span></p>
                  <ul v-for="(k,j) in swiperData.filter(item=>item.resourceType == 3)" :key="j" @click="tabsTask(k,j,'2')">


                    <li :class="k.isFinish == 1 && activeIndex == j?'isFinishActive':(k.isFinish != 1 && activeIndex == j?'active':(k.isFinish == 1 && activeIndex != j)?'isFinish':'')"   >
                      {{ j+1 }}
                      <!-- {{ k.isFinish }} -->
                      <!-- {{ activeIndex == j }} -->

                    </li>
                    <span>{{ k.name }} </span>
                  </ul>
                </div>
                <!-- 资料 -->
                <div class="material" v-if="swiperData.filter(item=>item.resourceType == 1).length">
                  <p><span>资料</span></p>
                  <ul v-for="(v,i) in swiperData.filter(item=>item.resourceType == 1)" :key="i"  @click="tabsMaterial(v,i,'2')">
                    <li :class="materialId == i?'active':''" >{{ i+1 }}</li>
                    <span>{{ v.name }} </span>
                  </ul>
                </div>
              </div>
              <!-- <div class="noCont" v-else>暂无内容</div> -->
            </el-collapse-item>
          </el-collapse>
      </div>

    </el-dialog>
  </div>
</template>
<script>
  /**
   *   wjl 修改了答案浮窗的样式 和任务提交后提示小弹框
   *               2021/1/29. 由于这种页面在系统中出现三次。这里给一个标识作为搜索标识。
   */

  import mySwiper from "../../../../subcomponent/swiper/index";
  import Note from "../../../../subcomponent/note/note";
  import mySwiperSmall from "../../../../subcomponent/courseList/index";
  import miniSwiper from "../../../../subcomponent/miniSwiper/miniSwiper";
  import myComponent from '../../../../myComponent'
  import pdf from "vue-pdf";
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
  import {moduleId} from "../../../../../store/modules/courseDetail";
  import './preview.scss';
  import axios from 'axios'
  import qs from 'qs'
  import dragIcon from './dragIcon'
  import * as api from '../../../../../api/courseApi'
  import * as api2 from "../../../../../api/testApi";
  import vEditor from "@/components/wjlEditor/index.vue";
  import platformBtn from "@/components/platformBtn/trainingNewBtn.vue"

  import JumpTemplate from '../../../../../components/JumpTemplate2.vue'  //
  export default {
    components: {
      mySwiper,
      mySwiperSmall,
      miniSwiper,
      myComponent,
      pdf,
      Note,
      dragIcon,
      vEditor,
      platformBtn,
      JumpTemplate
    },
    data() {
      return {
        courseId: this.$route.query.id,
        type: this.$route.query.type || sessionStorage.getItem("productFlag"), // 课程类型
        courseType: this.$route.query.courseType || sessionStorage.getItem("courseType"),  // 课程类型，判断用户是不是有权限跳转
        // courseName: this.$route.query.courseName,
        classId: this.$route.query.classId,
        className: this.$route.query.className,
        catalogId: 0,//当前学习的目录id
        workCatalogId:0,//任务列表的目录id
        userType: sessionStorage.getItem('userType'), //用户身份
        dialogSwiper: false,
        // show: false,
        // isShowAside: false,
        // isShowCenter: true,

        catalog: {}, //选中的目录
        swiperData: [], //课程目录下资源列表
        activeIndex: 0,

        catalogData: [], //课程目录列表
        listItem: {}, //显示详细课程内容 1,图片，2.文档，3，音频，4.视频
        expendId: [],//树节点默认展开
        resourceId: null,//上次学习记录的资源id
        postDirectory: {
          isEnd: 0,// 0 未看完，1，已看完 。资源是否看完
          seatno: 1,//资源学习次数
          resProgress: 1,//这条资源最后一次学习的时间
          totalResNum: 0,//总资源数
          resourceType: null
        },
        progress: 1,//资源进度
        pageNum: 1,//pdf上一页
        pageTotalNum: 1,//pdf下一页
        currentTime: 0,//视频，音频当前播放进度
        defaultProps: {
          children: "children",
          label: "catalogName"
        },

        iframeUrl: '',
        childrenIframeUrl:'',
        loading: true,
        vloading: false,

        // treeHeight: null,
        videoHeight: window.innerHeight - 250 + 'px',
        windowHeight: window.innerHeight,
        isZip: false,
        pdfEnlargStyle: '',
        pageStyle: '',
        pdfEnlargeSign: 1,
        isFinish: '../../../../../../static/images/study/icon/success.png',
        unFinish: '../../../../../../static/images/study/icon/unfinished.png',
        percentage: 0,//学习进度
        noteText: '笔记',
        classNames: null,

        optObject: {}, //科目id和班级id
        refresh: false, //刷新数据
        startTest: null,
        startTest1: null,
        score: null,
        pageRotate: 0,
        isViewAnswers: false,// 允许查看答案

        isBtn: false,
        // wjl
        isStartTime: '', // 记录视频观看的开始时间
        showFlag: true,
        myStation: [],
        statusFlag: true, //用来控制锁定的div 如果是false  就替换成锁定的盒子
        paperId: 0,

        examId: 0,
        statusLoading: true,

        // =============================================================
        buttonShowArr: [],//  跳转标识 试题中配置的动态参数
        templateCode: '',// templateCode
        //
        rolesStatus: 0,
        activeIndex: null,
        materialId: null,
        isMy: false,
        workListDialogVisible:false,
        // swiperDataCopy:[],
        envPreview: process.env.PREVIEW_URL,
        //
        activeCollapse: '',
      };
    },
    computed: {
      ...mapState(moduleId, {
        swiperFlag: state => state.swiperFlag,
        currentResource: state => state.currentResource,
        isShowRight: state => state.isShowRight,
        isShowNote: state => state.isShowNote,
      }),
    },
    watch: {
      'currentResource': function (newValue) {
        // 切换目录，保存之前看的视频时间
        if (this.isStartTime) {
          this.endVideo();
          this.isStartTime = ''
        }
        if (newValue.resourceType === 5) {
          //判断，考试作答，继续作答
          this.getStartTest(newValue.id);
        }
        this.listItem = newValue;
        this.getMsgFormSon(newValue);
        //判断显示隐藏按钮
        console.log(newValue,"newValue")
        if (newValue.resourceType == 3 && this.listItem.id) {  // 实操题，获取动态参数（跳转平台）
          // 获取动态参数
          this.getparams(this.listItem.id);
        }
      },
      "pageTotalNum": function (val) {
        // this.insertDirectory(1);
      },
    },
    created() {
      this.optObject = { ...this.$route.query };
      if (this.type == 3 || this.type == 7){
        this.getMyPost();// 获取岗位
      }else{
        this.init();
      }
    },
    mounted() {
      if (this.type == 3 || this.type == 7) {
        this.showFlag = true;
        // if (this.myStation.length) {
        //   this.treeHeight = window.innerHeight - (this.myStation.length * 30 + 150) + 'px';
        // } else {
        //   this.treeHeight = window.innerHeight - 210 + 'px';
        // }
      }
      // else {
      //   this.treeHeight = window.innerHeight - 189 + 'px';
      // }
    },
    methods: {
      ...mapActions(moduleId, [
        'setResourceList',
        'setResourceId',
        "setRight",
        "setSwiperFlag",
        "setCurrentResource",
      ]),
      ...mapMutations(moduleId, [
        'SET_NOTE',
        'SET_Right'
      ]),
      handleWork(){
        this.workCatalogId = this.catalogId
        this.workListDialogVisible = true

        // this.getWorkResource(this.workCatalogId )
        // console.log(this.swiperData)
      },
      changeWorkCollapse(val){
        // if(val){
        //   this.getWorkResource(this.workCatalogId )
        // }
      },


      init() {
        //根据班级id查询信息
        // this.getClassInfo()

        // 根据课程查询id查询目录接口
        this.getMenu();

        //统计进入次数
        this.studyNum();

        //获取学生学习进度
        this.getProcess();

        //隐藏笔记
        this.SET_NOTE(false);
      },
      getMyPost() { // 获取岗位
        api.getMyStation(
          this.courseId,
          this.classId
        ).then(res => {
          if (res.code == 0) {
            this.myStation = res.data;
            this.init();
          } else {
            this.$messageError(res.msg)
          }
        })
      },

      //统计进度
      courseProgress() {
        let data = {
          courseId: this.courseId,//课程id
          classId: this.classId,//班级id
        }
        api.statisticsProgress(data).then(rs => {
          // console.log('-----------------', rs);
        }).catch(function (error) {
          console.log(error);
        });
      },
      // 根据课程id 查询目录
      getMenu() {
        api.queryCourseCatalog( this.courseId, this.classId ).then(rs => {
          if (rs.code === "0") {
            if (rs.data.length > 0) {
              if (rs.data[0].resourceType == 3) {
                this.catalogData = rs.data[0].templates[0];
              } else {
                this.catalogData = rs.data;
              }
              // this.$store.state.noteItem = this.catalogData;
              // 查询上次学习位置
              this.selectDirectory();
            } else {
              this.statusLoading = false
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      },
      //目录定位
      setCurrent(id) {
        this.catalogId = id;
      },
      // 查询学习位置
      selectDirectory() {
        let that = this;
        let obj = {
          courseId: this.courseId,
          classId: this.classId,
        };
        api.selectDirectory(obj).then(rs => {
          if (rs.code == "0") {
            console.log(rs)
            let {catalogId, resourceId, resProgress, studySort} = rs.data;

            that.resourceId = resourceId;
            that.activeIndex = studySort;

            that.setResourceId(resourceId); //记录上次资源位置

            if (catalogId) {
              // that.catalogId = catalogId;
              // that.setCurrent(catalogId);

              that.$nextTick(() =>{
                let currentNode = this.catalogData.filter(item=>item.id == catalogId)[0]
                that.catalog = currentNode;
                if(currentNode){
                  if (that.userType == 2 || that.userType == 3) {
                    if (currentNode.status == false || currentNode.lockStatus == 1) {
                      that.catalogId = ''
                      that.statusFlag = false;
                    } else {
                      that.catalogId = catalogId;
                      that.setCurrent(catalogId);
                      that.statusFlag = true;
                    }
                  } else {
                    if (currentNode.lockStatus == 1) {
                      that.statusFlag = false;
                      that.catalogId = ''
                    } else {
                      that.catalogId = catalogId;
                      that.setCurrent(catalogId);
                      that.statusFlag = true;
                    }
                  }
                }
                that.getResource(catalogId, resourceId) //根据目录查询关联资源信息接口
                that.statusLoading = false
              })

            }
            if (resProgress) {
              that.progress = resProgress;
            }


          } else if (rs.code == "2") {
            //默认显示第一章节的资源
            if (that.catalogData.length > 0) {
              let catalogId = that.catalogData[0].id;
              that.catalogId = catalogId;
              that.setCurrent(catalogId);
              that.getResource(catalogId);
              if (that.userType == 2 || that.userType == 3) {
                if (that.catalogData[0].status == false || that.catalogData[0].lockStatus == 1) {
                  that.statusFlag = false;
                } else {
                  that.statusFlag = true;
                }
              } else {
                if (that.catalogData[0].lockStatus == 1) {
                  that.statusFlag = false;
                } else {
                  that.statusFlag = true;
                }
              }
              that.statusLoading = false
            }
          }

        }).catch(function (error) {
          console.log(error);
        }).finally(()=>{
          this.loading = false;
        })
      },
      //根据目录查询资源
      getResource(id, resourceId) {
        let obj = {
          catalogId: id,
          classId: this.classId,
          courseId: this.courseId,
        };
        api.queryTask(obj).then(rs => {
          if (rs.code === "0") {
            this.swiperData = rs.data;  //  目录绑定的资源
            // 选中一项
            this.openRightContent(resourceId);
          }
        })
      },
      openRightContent(resourceId){
        if (this.swiperData.length > 0) {
          this.setResourceList(this.swiperData);
          let taskArr = this.swiperData.filter(item=>item.resourceType == 3)
          console.log('任务-----------',taskArr)
          let materialIdArr = this.swiperData.filter(item=>item.resourceType == 1)
          console.log('资料-----------',materialIdArr)
          if(taskArr.length) {
            this.materialId = null
            this.activeIndex = 0
            this.setResourceId(taskArr[0].id);
            this.setCurrentResource(taskArr[0]);
          }
          if(materialIdArr.length && taskArr.length == 0) {
            this.materialId = 0
            this.activeIndex = null
            this.setResourceId(materialIdArr[0].id);
            this.setCurrentResource(materialIdArr[0]);
          }
          //默认显示第一个资源
          this.postDirectory.totalResNum = this.swiperData.length;

          if (resourceId) {
            this.resourceId = resourceId;
            this.swiperData.forEach(item => {
              if (item.id == resourceId) {
                this.listItem = item;
              }
            });
            this.getMsgFormSon(this.listItem);
            //判断，考试作答，继续作答
            this.getStartTest(resourceId);


          }else{
            this.listItem = this.swiperData[0];
            this.resourceId = this.swiperData[0].id;
            //判断，考试作答，继续作答
            this.getStartTest(this.resourceId);
            this.setResourceId(this.resourceId);
            this.getMsgFormSon(this.swiperData[0]);

          }
          if (this.listItem.templates && this.listItem.id) {
            // 获取动态参数
            this.getparams(this.listItem.id, this.listItem.templates[0].id);
          }

        }else {
          this.listItem = {};
          this.catalogId = null;
          this.resourceId = null;
        }
        this.loading = false;
      },
      // getWorkResource(id){
      //   let obj = {
      //     catalogId: id,
      //     classId: this.classId,
      //     courseId: this.courseId,
      //   };
      //   api.queryTask(obj).then(rs => {
      //     if(rs.code == 0){
      //       this.loading = false;
      //       this.swiperDataCopy = rs.data;
      //     }
      //   })
      // },
      //根据资源ID 获取动态参数列表
      getparams(id,type) {
        let platBtn = {};
        api.getQuestionDynmaicParam(id).then(rs => {
          if(rs.code === "0" && rs.data && rs.data[0]){
            rs.data[0].forEach( item=> {
              if (item.param === 'templateCode') this.templateCode = item.value;
            })

            let stationArr = this.myStation.map(sm => {
              return sm.code
            })

            for (let o in rs.data) {
              let eventRoles = '';

              rs.data[o].forEach(item => {
                if (item.param === 'roles'){
                  eventRoles = item.value
                }
              })

              rs.data[o].forEach(item => {
                if (item.param === 'platform') {
                  if (String(this.type) === '3' || String(this.type) === '7'){
                    if (stationArr.indexOf(eventRoles) > -1){
                      platBtn[item.value] = o;
                      // platBtn.push({
                      //   platform: item.value,
                      //   index: o
                      // })
                    }
                  }else{
                    platBtn[item.value] = o;
                  }
                }
              })
            }
            if (Object.keys(platBtn).length){
              this.rolesStatus = 0
            }else{
              this.rolesStatus = 1
            }
          }else{
            this.rolesStatus = 2
          }
          this.buttonShowArr = [];
          for (const o in platBtn) {
            this.buttonShowArr.push({
              platform: o,
              index: platBtn[o]
            })
          }
          if(type == 'next'){
            this.$nextTick(()=>{
                  this.$refs.platformBtn.startFn(this.buttonShowArr[0].platform, 0, 0)
                })
          }
          console.log('--type:::', this.type, '--courseType:', this.courseType, '--platform:', this.buttonShowArr)
        })
      },

      getMsgFormSon(data) {
        let {id, resourceType} = data;
        let that = this;
        that.startTest = null;
        that.startTest1 = null;
        that.listItem = data;
        that.examId = null;
        if (data.show) {
          this.isViewAnswers = true
        } else {
          this.isViewAnswers = false
        }
        that.isZip = false;
        that.resourceId = id;
        that.pageRotate = 0;
        that.postDirectory.resourceType = resourceType;
        console.log(data)
        async function timeOut() {
          let progress = await that.selectResource(that.courseId, that.classId, that.catalogId, id, resourceType);
          that.postDirectory.resProgress = progress;
          //点击右侧资源记录学习进度
          if (data.type == 1) {
            // that.insertDirectory(1);
          } else if (data.type == 2) {
            that.loading = true;
            that.loadPdfHandler();
          } else if (data.type == 3) {
            // that.insertDirectory(0);
            that.$nextTick(function () {
              let ref = that.$refs.audioC;
              let allTime;
              ref.load();
              ref.currentTime = progress;
              ref.onloadedmetadata = function () {
                allTime = this.duration;
              };
              ref.addEventListener('pause', function () {
                that.AudioTime(allTime, this.paused);
              })
              ref.addEventListener('play', function () {
                that.AudioTime(allTime, this.paused);
              })
              ref.addEventListener('timeupdate', function () {
                that.postDirectory.resProgress = parseInt(this.currentTime);
                clearTimeout(that.setAudio);
                that.setAudio = setTimeout(() => {
                  // that.insertDirectory(1);
                }, 500);
              })
              ref.addEventListener('ended', function (event) {
                that.postDirectory.resProgress = parseInt(this.currentTime);
                // that.insertDirectory(1);
              })
            })
          } else if (data.type == 4) {
            // that.insertDirectory(1);
            that.$nextTick(function () {
              let ref = that.$refs.videoC;
              let allTime;
              ref.load();
              ref.currentTime = progress;
              ref.onloadedmetadata = function () {
                allTime = this.duration;
              };
              ref.addEventListener('pause', function () {
                that.videoTime(allTime, this.paused);
              })
              ref.addEventListener('play', function () {
                that.videoTime(allTime, this.paused);
              })
              ref.addEventListener('timeupdate', function () {
                that.postDirectory.resProgress = parseInt(this.currentTime);
                clearTimeout(that.setVideo);
                that.setVideo = setTimeout(() => {
                  // that.insertDirectory(1);
                }, 500);
              })
              ref.addEventListener('ended', function (event) {
                that.postDirectory.resProgress = parseInt(this.currentTime);
                // that.insertDirectory(1);
              })
            })
          } else if (data.type == 5) {
            axios.post(`${process.env.UPLOAD_NAME}` + '/file/doesObjectExistZip', qs.stringify({filePath: data.newAttaUrl}), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: 'bearer ' + localStorage.getItem('Authorization')
              },
            }).then(res => {
              if (res.data.code == 0) {
                that.isZip = true
              } else {
                that.isZip = false
              }
            }).catch(error => {
              console.log(error);
            })

            // that.insertDirectory(1);
          } else if (data.resourceType == 3) {

            that.insertDirectory(data.isFinish);
          }
          return false;
        }

        timeOut();
      },
      changeSwitch(val){
        console.log(val)
        this.selectViewAnswers(this.listItem)
      },
      //是否允许查看答案
      selectViewAnswers(item) {
        // let tipsMsg = ''
        // let status = 0
        // if (this.isViewAnswers) {
        //   tipsMsg = '是否取消查看答案'
        //   status = 0
        // } else {
        //   tipsMsg = '是否允许查看答案'
        //   status = 1
        // }

        let obj = {
          classId: this.$route.query.classId,
          courseId: this.$route.query.id,
          catalogId: this.catalogId,
          questionId: item.id,
          resourceId: item.id,
          resourceType: item.resourceType,
          status: this.listItem.show?1:0,
        }
        api.isAnswers(obj).then(rs => {
          if (rs.code === '0') {
            // if (tipsMsg == '是否允许查看答案') {
            //   this.isViewAnswers = true
            // } else {
            //   this.isViewAnswers = false
            // }
            this.$set(this.listItem, 'show', this.listItem.show)
            this.$messageSuccess('设置成功')
            // this.init()
          } else {
            this.$messageError(rs.msg)
          }
        }).catch(err => {
          console.log(err)
        })

        // this.$tipsDialog(
        //   "提示",
        //   tipsMsg,
        //   '',
        //   "el-icon-warning",
        //   "rgb(255, 178, 60)"
        // ).then(() => {
        //   api.isAnswers(obj).then(rs => {
        //     if (rs.code == 0) {
        //       if (tipsMsg == '是否允许查看答案') {
        //         this.isViewAnswers = true
        //       } else {
        //         this.isViewAnswers = false
        //       }
        //       this.$messageSuccess('设置成功')
        //       // this.init()
        //     } else {
        //       this.$messageError(rs.msg)
        //     }
        //   }).catch(err => {
        //     console.log(err)
        //   })
        // }).catch(() => {
        //   if (tipsMsg == '是否允许查看答案') {
        //     this.isViewAnswers = false
        //   } else {
        //     this.isViewAnswers = true
        //   }
        // });
      },
      //=======================================================================
      // 跳转答案对比
      answerCompareBtn() {
        let obj = Object.assign({}, this.postDirectory);
        console.log(obj);
        let newUrl = this.$router.resolve({
          path: "/answerCompare",
          query: {
            classId: this.classId,
            userId: sessionStorage.getItem("userId"),
            courseId: this.courseId,
            questionId: this.resourceId,
            teamId: this.myStation.length ? this.myStation[0].teamId : '',
            type: this.type,
          }
        });
        window.open(newUrl.href, "_blank");
      },
      download(id) {//下载
        let url = `${process.env.UPLOAD_NAME}/file/downloadFiles?id=` + id;
        this.$downloadFun(url)
      },
      // toggleSwiper() {
      //   this.setRight(!this.isShowRight);
      // },
      toggleDialogSwiper() {
        this.dialogSwiper = !this.dialogSwiper;
      },
      //点击左侧目录切换资源
      changeCollapse(val) {

        if(val) {

          if(this.activeCollapse === val) return;
          this.activeCollapse = val;

          let data = this.catalogData.filter(item=>item.id == val)[0]
          if (this.userType == 2 || this.userType == 3) {
            if (data.status == false || data.lockStatus == 1) {
              this.statusFlag = false;
            } else {
              this.statusFlag = true;
            }
          } else {
            if (data.lockStatus == 1) {
              this.statusFlag = false;
            } else {
              this.statusFlag = true;
            }
          }
          if ((this.userType == 2 || this.userType == 3) && !data.status) {
            console.log('锁定')
            return
          }
          if ((this.userType == 0 || this.userType == 1) && data.lockStatus == 1) {
            console.log('锁定')
            return
          }
          this.catalog = data;
          this.$store.state.noteItem = data;
          this.activeIndex = 0;
          this.catalogId = data.id;
          this.swiperData = [];  //  目录绑定的资源
          this.listItem = null;
          this.loading = true;

          this.changeMy(this.isMy)
          // this.getResource(data.id);
          // this.isMy = false

          //隐藏笔记
          this.SET_NOTE(false);
          this.noteText = '笔记';

          //修改当前url参数
          let query = this.$router.history.current.query
          let path = this.$router.history.current.path
          let newQuery = JSON.parse(JSON.stringify(query));
          newQuery.tabId = data.id;
          this.$router.push({path, query: newQuery});

          // 切换目录，保存之前看的视频时间
          if (this.isStartTime) {
            this.endVideo();
            this.isStartTime = ''
          }
          if ((this.type == 3 || this.type == 7) && this.$refs.myswiper) {
            this.$refs.myswiper.tab(0);
          }
        }

      },
      AudioTime(allTime, isPaused) {//设置定时器
        if (!isPaused) {
          clearInterval(this.intervalFunc);
          this.intervalFunc = setInterval(() => {
            this.postDirectory.resProgress = parseInt(this.$refs.audioC.currentTime);
            this.insertDirectory(0);
          }, 5000)
        }
        if (isPaused) {
          clearInterval(this.intervalFunc)
        }
      },
      videoTime(allTime, isPaused) {//设置定时器
        if (!isPaused) {
          clearInterval(this.intervalFunc);
          this.intervalFunc = setInterval(() => {
            this.postDirectory.resProgress = parseInt(this.$refs.videoC.currentTime);
            this.insertDirectory(0);
          }, 5000)
        }
        if (isPaused) {
          clearInterval(this.intervalFunc);
        }
      },
      prePage(e) {
        let p = this.pageNum;
        p = p > 1 ? p - 1 : this.pageTotalNum;
        this.pageNum = p;

        this.postDirectory.resProgress = this.pageNum;
        if (this.pageTotalNum === this.pageNum) {
          // this.insertDirectory(1);
        }else{
          // this.insertDirectory(0);
        }

        e.target.parentNode.scrollTo(0, 0);
      },
      nextPage(e) {
        let p = this.pageNum;
        p = p < this.pageTotalNum ? p + 1 : 1;
        this.pageNum = p;
        this.postDirectory.resProgress = this.pageNum;
        if (this.pageTotalNum === this.pageNum) {
          // this.insertDirectory(1);
        }else{
          // this.insertDirectory(0);
        }
        e.target.parentNode.scrollTo(0, 0);
      },
      clock() {
        this.pageRotate += 90
      },
      counterClock() {
        this.pageRotate -= 90
      },
      pdfdblclick() {
        if (this.pdfEnlargeSign == 1) {
          this.pdfEnlargeSign = 2
          this.pdfEnlargStyle = "pdf_enlarge"
          this.pageStyle = "page_style"
        } else {
          this.pdfEnlargeSign = 1
          this.pdfEnlargStyle = ""
          this.pageStyle = ""
        }
      },
      loadPdfHandler(e) {
        this.pageNum = this.progress; // 加载的时候先加载第一页
        this.loading = false;
      },

      getActiveIndex(index){
        this.activeIndex = index;
      },
      insertDirectory(isEnd) { //插入目录学习位置
        console.log(this.activeIndex)
        let param = {
          catalogId: this.catalogId, //当前学习的目录id
          courseId: this.courseId, //课程id
          resourceId: this.resourceId,
          studySort: this.activeIndex >= 0 ?this.activeIndex:this.materialId,   //用于回显选中。
          classId: this.classId,
          isEnd: isEnd ? isEnd : 0, // 0 未看完，1，已看完 。资源是否看完
          seatno: this.postDirectory.seatno, //资源学习次数
          resProgress: this.postDirectory.resProgress, //这条资源最后一次学习的时间
          totalResNum: this.postDirectory.totalResNum, //总资源数
          resourceType: this.postDirectory.resourceType,
        }
        api.insertDirectory(param).then( res => {
          if (res.code === '0' && this.swiperData){
            let taskArr = this.swiperData.filter(item=>item.resourceType == 3)
            if(this.activeIndex >= 0) {
              this.$set(taskArr[this.activeIndex], 'isFinish', isEnd)
            }

            this.setResourceList(this.swiperData);
            if (res.data === 1 && this.catalog.isFinish !== 1){
              this.getMenu()
            }

          }
          //更新学生学习进度
          this.getProcess();

        }).finally(()=>{
          this.vloading = false;
        })

      },
      selectResource(courseId, classId, catalogId, resourceId, resourceType) {//查询资源进度
        let obj = {};
        obj.courseId = courseId;
        obj.classId = classId;
        obj.catalogId = catalogId;
        obj.questionId = resourceId;
        obj.isEnd = 0;
        obj.seatno = 1;
        obj.resProgress = 1;
        obj.totalResNum = this.swiperData.length;
        obj.resourceType = resourceType;
        return new Promise((resolve) => {
          api.qryResProgress(obj).then(rs => {
            if (rs.code == "0") {
              if (rs.data == null) {
                resolve(0);
              } else {
                this.progress = rs.data.resProgress == 0 ? 1 : rs.data.resProgress;
                this.loadPdfHandler();
                resolve(rs.data.resProgress);
              }
            } else {
              resolve(1);
            }
          })
            .catch(function (error) {
              console.log(error);
            });
        })
      },

      /*
   *  平台跳转
   *   openType  链接打开方式，0主页面打开。1副页面打开，2新窗口打开
   *   author: wjl
   */
      platformJump(data, openType) {
        if (!data.iframeUrl) return;

        console.log(this.myStation)
        this.$nextTick(() => {
          if (openType === 0) {
            this.iframeUrl = data.iframeUrl
          } else if (openType === 1) {
            this.childrenIframeUrl = data.iframeUrl
          } else if (openType === 2) {
            window.open(data.iframeUrl)
          }
          this.isBtn = true;
          this.insertDirectory(this.listItem.isFinish);
        })


      },

      showNote() {//点击显示隐藏笔记
        this.setSwiperFlag(false);//隐藏资源列表
        this.SET_NOTE(!this.isShowNote);//显示笔记
        if (this.isShowNote) {
          if (this.type == 3 || this.type == 7) {
            this.showFlag = false;
          }
          this.noteText = '收起';
        } else {
          if (this.type == 3 || this.type == 7) {
            this.showFlag = true;
          }
          this.noteText = '笔记';
        }
      },
      getStartTest(paperId) {//判断，考试作答，继续作答
        let obj = {
          "catalogId": this.catalogId,
          "userId": sessionStorage.getItem("userId"),
          "classId": this.$route.query.classId,
          "paperId": paperId,
          "courseId": this.$route.query.id
        };
        this.paperId = paperId
        api.getStartTest(obj).then((res) => {
          if (res.code === "0") {
            //根据uerType判断老师还是学生，学生显示开始作答按钮，老师显示进入测验按钮
            if (sessionStorage.getItem("userType") == 2) {
              this.startTest = res.data.status;
              this.startTest1 = res.data.status1;
              this.examId = res.data.examId;
              this.score = res.data.score;
            } else {
              this.startTest = "enter";
            }
            // 这里需要加一个 字段来判断重来一次
          }
        });
      },
      beginTest(data, state) { //跳转到考试
        this.insertDirectory(0);
        const {href} = this.$router.resolve({
          path: "/switch/test/testPaper",
          query: {
            id: this.$route.query.id,
            classId: this.$route.query.classId,
            paperId: data.id,
            paperCode: data.testPaper.paperCode,
            classNames: this.classNames,
            paperName: data.testPaper.paperName,
            paperScore: data.testPaper.paperScore,
            count: data.testPaper.count,
            total: data.testPaper.count,
            className: this.classNames,
            questionId: this.resourceId,
            catalogId: this.catalogId,
            finishFlag: 1,
            type: 0
          }
        });
        if (state) {
          api2.getExamTestCount(this.examId, this.$route.query.id, this.$route.query.classId).then(rs => {
            this.Challenge = rs.data
            if (this.Challenge) {
              this.$tipsDialog(
                "提示",
                `你还有${this.Challenge}次重做机会，测验成绩取历次作答成绩最高分哦！`,
                "",
                "",
                "rgb(255, 178, 60)"
              ).then(() => {
                window.open(href, '_blank');
              }).catch(() => {

              })
            } else {
              window.open(href, '_blank');
            }
          })
          setTimeout(() => {
            this.getStartTest(this.paperId)
          }, 5000)
          return
        } else {
          window.open(href, '_blank');
          setTimeout(() => {
            this.getStartTest(this.paperId)
          }, 5000)
        }

      },
      //老师进入预览
      intoPreview(data) {
        this.insertDirectory(1);
        const {href} = this.$router.resolve({
          path: '/switch/test/preview',
          query: {
            paperId: data.id,
            total: data.testPaper.count,
            id: this.$route.query.id,
            classId: this.$route.query.classId,
            className: this.$route.query.className,
            finishFlag: 1
          }
        });
        window.open(href, '_blank');
      },
      //作答详情
      intoStuPreview(data) {
        const {href} = this.$router.resolve({
          path: '/switch/test/stupreview',
          query: {
            id: this.$route.query.id,
            classId: this.$route.query.classId,
            userId: sessionStorage.getItem('userId'),
            paperId: data.id,
            total: data.testPaper.count,
            className: this.$route.query.className,
            finishFlag: 1,
            type: 0
          }
        });
        window.open(href, '_blank');
      },
      /* 视频播放结束 */
      endVideo() {
        let endTime = new Date().getTime();
        if (this.isStartTime && endTime - this.isStartTime > 5 * 1000) {
          let data = {
            ext: JSON.stringify(this.listItem.newAttaUrl),
            "endTime": endTime,
            "routeUrl": process.env.BASE_API + this.$route.fullPath,
            "startTime": this.isStartTime,
            "time": Math.ceil((endTime - this.isStartTime) / 1000),
            "userId": window.sessionStorage.getItem('userId')
          }
          api.endVideo(data).then(() => {
          })
        }
      },
      /* 视频播放开始 */
      videoPlay() {
        this.isStartTime = new Date().getTime();
      },

      //获取学生学习进度
      getProcess() {
        api.getStudentProgress({
          courseId: this.courseId,
          classId: this.classId,
        }).then((result) => {
          if (result.code === "0") {
            this.percentage = Number(result.data);
          }
        });
      },

      //统计进入次数
      studyNum() {
        let data = {
          courseId: this.courseId,//课程id
          classId: this.classId,//班级id
        }
        api.statisticsStudyNum(data)
      },
      // 点击任务
      tabsTask(item,index,type){
        if(type =='2'){
          this.catalogId = this.workCatalogId
          this.workListDialogVisible = false
          // this.swiperData = this.swiperDataCopy;
          // this.getResource(item.id)

        }
        this.materialId = null
        this.activeIndex = index
        this.setResourceId(item.id);
        this.setCurrentResource(item);
      },
      // 点击资料
      tabsMaterial(item,index,type){
        if(type =='2'){
          this.catalogId = this.workCatalogId
          this.workListDialogVisible = false
          // this.swiperData = this.swiperDataCopy;
          // this.getResource(item.id)


        }
        this.activeIndex = null
        this.materialId = index
        this.setResourceId(item.id);
        this.setCurrentResource(item);
      },
      // 切换我的
      changeMy(val) {
        if(val) {
          api.getMmTask(this.$route.query.id, this.catalogId, this.$route.query.classId).then(res=>{
            if(res.code == 0){
              console.log(res)
              this.swiperData = res.data;
              // 选中一项
              this.openRightContent();
            }else{
              this.$messageError(res.msg)
            }
          })
        }else{
          this.getResource(this.catalogId)
        }
      },
    async  nextQuestion(type){
        if(this.swiperData.length) {
          let list = this.swiperData.filter(item=>item.resourceType == 3)
          if(list.length){
            if(type == 'next') { //下一题
              this.activeIndex++
              if(list.length >= this.activeIndex+1){
                let item = list[this.activeIndex]
                this.setResourceId(item.id);
                this.setCurrentResource(item);
                await this.getparams(item.id,'next')
              }else{
                this.activeIndex = list.length - 1
                this.$messageError("该章节下最后一个任务啦")

                return false
              }
            }else{ // 上一题
              this.activeIndex--
              if(this.activeIndex >= 0){
                let item = list[this.activeIndex]
                this.setResourceId(item.id);
                this.setCurrentResource(item);
                this.getparams(item.id)
              }else{
                this.activeIndex = 0
                this.$messageError("该章节下第一个任务啦")
                return false
              }
            }
          }
        }
      }
      // //根据班级id查询信息
      // getClassInfo() {
      //   let that = this
      //   api.getClassInfo(this.classId).then(rs => {
      //     if (rs.code === "0") {
      //       //科目名字
      //       that.className = rs.data.subjectName;
      //       //班级名字
      //       that.classNames = rs.data.name;
      //     }
      //   })
      // },
    }
  }
</script>

<style lang="scss">
  .study2022-5-26 {
    width: 100%;
    height: 100%;
    position: relative;


    .course_content {
      width: 100%;
      height: 100%;
      background: rgba(244, 244, 244, 1);
      display: flex;

      .course_left {
        height: calc(100% - 18px);
        width: 320px;
        border-radius: 4px;
        margin-top: 16px;
        margin-left: 16px;
        position: relative;
        display: flex;
        flex-direction: column;
        .study_zonghe {
          width: 100%;
          // height: 231px;
          background: #FFF;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          padding: 16px 15px;
          .right {
            margin-bottom: 23px;
            p {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              span {
                color: #A9AEBB;
                font-size: 12px;
              }
            }
            .study_progress_box {
              width: 288px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              line-height: 24px;
              text-align: center;
              border-radius: 17px;
              border: 1px solid #215DE8;
              .circle_progress {
                width: 97%;
                height: 16px;
              }
            }
          }

          .left {
            p {
              color: #A9AEBB;
              font-size: 12px;
              margin-bottom: 10px;
            }
            .station {
              max-height: 108px;
              overflow-y: auto;
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
              row-gap: 8px;
              li {
                width: 136px;
                height: 32px;
                background: #EFF4FF;
                text-align: center;
                line-height: 32px;
                font-size: 12px;
                color: #000000;
              }
            }
            .noStation {
              height: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }

        .course_tree {
          flex: 1;
          overflow: auto;
          width: 100%;
          margin-top: 8px;
          overflow: auto;
          background-color: #fff;
          border-radius: 4px;
          padding: 11px 12px;
          box-sizing: border-box;
          .status_box {
            height: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .status_left {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              gap: 29px;
            }
            li {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              gap: 8px;
              i {
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
              }
              span {
                font-size: 12px;
                color: #666;
              }
              &:nth-child(1) {
                i {
                  background-color: #48C79C;
                }
              }
              &:nth-child(2) {
                i {
                  background-color: #FF8D17;
                }
              }
              &:nth-child(3) {
                i {
                  background-color: #F4F5F6;
                }
              }
            }
            .work_list{
              color:  #0052D9;
              font-size: 12px;
              font-weight: 400;
              text-decoration-line: underline;
              cursor: pointer;

            }
          }
          .collapse_item {
            margin-bottom: 4px;
            border-radius: 2px;
          }
          .el-collapse {
            margin-top: 15px;
            border: 0;
            .el-collapse-item__header {
              height: 40px;
              line-height: 48px;
              font-size: 14px;
              font-weight: 600;
              border-radius: 2px;
              background: #F4F5F6;
              padding-left: 16px;
              border: 0;
              .title_cont {
                display: inline-block;
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .is_finish {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
              }
            }
            .el-collapse-item__wrap {
              border: 0;
            }
            .el-collapse-item__content {
              padding-bottom: 24px;
              .cont {
                padding: 0 16px;
                .task,.tasks,.material {
                  p {
                    height: 28px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.40);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                  ul {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 24px;
                    row-gap: 16px;
                    margin-top: 5px;
                    li {
                      position: relative;
                      width: 32px;
                      height: 32px;
                      background: #F4F5F6;
                      text-align: center;
                      line-height: 32px;
                      cursor: pointer;
                    }
                    li.active {
                      line-height: 30px;
                      font-weight: 600;
                      &::after {
                        position: absolute;
                        content: '';
                        width: 0;
                        height: 0;
                        border-top: 4px solid transparent;
                        border-left: 4px solid transparent;
                        border-right: 4px solid transparent;
                        border-bottom: 4px solid #215DE8;
                        bottom: -8px;
                        left: 11px;
                      }
                    }
                    li.isFinishActive {
                      color: #FFF;
                      line-height: 30px;
                      font-weight: 600;
                      background: #48C79C;
                      &::after {
                        position: absolute;
                        content: '';
                        width: 0;
                        height: 0;
                        border-top: 4px solid transparent;
                        border-left: 4px solid transparent;
                        border-right: 4px solid transparent;
                        border-bottom: 4px solid #215DE8;
                        bottom: -8px;
                        left: 11px;
                      }
                    }
                    li.isFinish {
                      color: #FFF;
                      line-height: 32px;
                      background: #48C79C;
                    }
                    // li.inprogressActive{
                    //   color: #FFF;
                    //   line-height: 30px;
                    //   font-weight: 600;
                    //   background:  #F2A36D;
                    //   &::after {
                    //     position: absolute;
                    //     content: '';
                    //     width: 0;
                    //     height: 0;
                    //     border-top: 4px solid transparent;
                    //     border-left: 4px solid transparent;
                    //     border-right: 4px solid transparent;
                    //     border-bottom: 4px solid #215DE8;
                    //     bottom: -8px;
                    //     left: 11px;
                    //   }


                    // }
                    // li.inprogress {
                    //   color: #FFF;
                    //   line-height: 32px;
                    //   background: #F2A36D;
                    // }
                  }
                }
                .task,.tasks {
                  ul {
                    li {
                      border-radius: 20px;
                    }
                  }
                }
                .task {
                  padding-bottom: 24px;
                }
                .material {
                  ul {
                    li {
                      border-radius: 4px;
                    }
                  }
                }
              }
            }
          }
        }
      }

      .course_main {
        flex: 1;
        height: calc(100% - 18px);
        margin: 16px;
        overflow: hidden;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        box-sizing: border-box;
        position: relative;

        .show_main {
          width: 100%;
          margin: auto;
          overflow: hidden;
          position: relative;

          .title {
            width: calc(100% - 96px);
            margin: 15px 48px;
            padding-bottom: 15px;
            padding-right: 100px;
            box-sizing: border-box;
            height: 20px;
            border-bottom: 1px solid #5397F7;

            .task_name {
              width: auto;
              display: block;
              font-size: 14px;
              font-weight: bold;
              color: rgba(51, 51, 51, 1);
              text-indent: 10px;
              float: left;
            }

            button {
              position: absolute;
              right: 48px;
              top: 8px;
              width: 60px;
              height: 24px;
              background: rgba(255, 255, 255, 1);
              border: 1px solid rgba(83, 151, 247, 1);
              border-radius: 4px;
              font-size: 12px;
              font-weight: 400;
              color: rgba(83, 151, 247, 1);
              cursor: pointer;

              &:hover {
                color: #fff;
                background: #5397F7;
              }
            }

            .is_view_answers {
              /*width: 100px;*/
              height: 20px;
              position: absolute;
              right: 50px;
              top: 12px;
              cursor: pointer;
              display:flex;
              align-items: center;

              i {
                width: 14px;
                height: 14px;
                /*position: absolute;*/
                /*left: 0;*/
                /*top: 0;*/
              }

              .true {
                background: url('../../../../../../static/images/study/icon/sty-checkbox.png') no-repeat;
                background-size: 100% 100%;
              }

              .false {
                background: url('../../../../../../static/images/study/icon/sty-checkbox-no.png') no-repeat;
                background-size: 100% 100%;
              }

              span {
                font-size: 12px;
              }
            }
          }

          .img_wrap {
            width: 100%;
            height: calc(100% - 60px);
            overflow: hidden;
            overflow-y: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;

            img {
              max-width: 100%;
            }

            .operating_btn {
              position: absolute;
              width: 100%;
              bottom: 0;

              div {
                margin: auto;
                width: 100px;

                i {
                  font-size: 20px;
                  color: #5397F7;
                  margin-left: 10px;
                  cursor: pointer;
                }
              }

            }
          }

          .pdf_wrap {
            width: 100%;
            height: calc(100% - 60px);
            overflow: hidden;
            overflow-y: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;

            .btn-pre {
              position: absolute;
              left: 10px;
              top: 50%;
              padding: 5px 5px;
              margin: auto;
              font-size: 16px;
              width: 28px;
              height: 28px;
              background: rgba(0, 0, 0, 0.2);
              text-align: center;
              line-height: 28px;
              border-radius: 50%;
              cursor: pointer;

              &:hover {
                background: #5397F7;
                color: white;
              }
            }

            .btn-next {
              position: absolute;
              right: 10px;
              top: 50%;
              padding: 5px 5px;
              margin: auto;
              font-size: 16px;
              width: 28px;
              height: 28px;
              background: rgba(0, 0, 0, 0.2);
              text-align: center;
              line-height: 28px;
              border-radius: 50%;
              cursor: pointer;

              &:hover {
                background: #5397F7;
                color: white;
              }
            }

            .pdfCurrentPage {
              position: absolute;
              right: 50%;
              bottom: 15px;
            }

            .operating_btn {
              position: absolute;
              bottom: 2px;
              right: 10px;
              display: flex;
              align-items: center;

              i {
                margin-left: 10px;
                text-align: center;
                font-size: 28px;
                color: #5397F7;
                cursor: pointer;
              }

              span {
                border: 1px solid #ccc;
                background: #ccc;
              }
            }

          }

          .zip_wrap {
            width: 100%;
            height: calc(100% - 130px);
            overflow: auto;
            display: block;
            padding: 0 48px;
            box-sizing: border-box;
          }

          audio {
            margin-left: 48px;
          }

          video {
            width: calc(100% - 96px);
            margin: auto;
          }

          .test_wrap {
            ul {
              width: 100%;
              margin-top: 10%;
              display: flex;
              justify-content: space-around;

              li {
                width: 220px;
                height: 160px;
                border-radius: 16px;
                position: relative;

                &:nth-child(1) {
                  background: #5397F7
                }

                &:nth-child(2) {
                  background: #34D3B0
                }

                &:nth-child(3) {
                  background: #FF9E70
                }

                &:nth-child(4) {
                  background: #3CBFFF
                }

                &:nth-child(5) {
                  background: #3CBFFF
                }

                &:nth-child(6) {
                  background: #3CBFFF
                }

                h3 {
                  font-size: 24px;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 1);
                  position: absolute;
                  left: 32px;
                  top: 36px;
                  max-height: 48px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  line-height: 32px;
                }

                p {
                  font-size: 16px;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 1);
                  position: absolute;
                  left: 32px;
                  bottom: 48px;
                }

                img {
                  width: 102px;
                  position: absolute;
                  right: 14px;
                  bottom: 14px;
                }
              }
            }
          }

          .startPractice_box {
            display: flex;
            justify-content: center;
          }

          .startPractice {
            display: inline-block;
            width: 140px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: rgba(83, 151, 247, 1);
            opacity: 1;
            border-radius: 4px;
            font-size: 14px;
            color: rgba(255, 255, 255, 1);
            margin: 100px 20px;
            cursor: pointer;
          }

          #note {
            position: absolute;
            right: 0;
            bottom: 15%;
            cursor: pointer;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-around;
            width: 67px;
            height: 111px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(230, 230, 230, 1);
            opacity: 1;
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
            color: #5397F7;

            .btn {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-evenly;
              flex: 1;
            }

            .feed_back {
              border-bottom: 1px solid #E2E2E2;
            }

            span {
              font-size: 12px;
              color: #5397F7;
            }

            .imgBox {
              width: 18px;
              height: 18px;

              img {
                display: inline-block;
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .show_main_null {
          text-align: center;

          img {
            width: 280px;
            margin-top: 80px;
          }

          P {
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-top: 10px;
          }
        }

        .btn_wrap {
          width: calc(100% - 96px);
          height: 64px;
          line-height: 64px;
          position: absolute;
          bottom: 0;
          border-top: 1px solid #DEDEDE;
          font-size: 13px;
          font-weight: 600;
          text-align: center;
        }

        .ql-editor {
          font-size: 14px;
        }
      }

      .course_right {
        width: 220px;
        height: calc(100% - 32px);
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        margin-top: 16px;
        margin-right: 16px;

        .course_swiper {
          width: 200px;
          height: 680px;
          /*overflow: hidden;*/
        }

        .swiper-toggle {
          position: absolute;
          top: 50%;
          left: -16px;
          width: 20px;
          height: 64px;
          margin-top: -32px;
          cursor: pointer;
          background: url("../../img/open.png");
          background-size: 100% 100%;
        }

        .swiper-open {
          background: url("../../img/close.png");
          background-size: 100% 100%;
        }
      }

      .menu-toggle {
        position: fixed;
        top: 50%;
        left: 264px;
        width: 16px;
        height: 64px;
        margin-top: -32px;
        cursor: pointer;
        background: url("../../img/close.png");
        background-size: 100% 100%;
      }

      .menu-open {
        left: 0;
        background: url("../../img/close_right.png");
        background-size: 100% 100%;
      }
    }
    .work_list_dialog{
     .el-dialog{
        border-radius: 4px;
      }
      .el-dialog__header {
        background: #F7F8FA;
        border-radius: 8px 8px 0px 0px;
        padding: 12px 24px;
        span{
          color: rgba(0, 0, 0, 0.90);
          font-size: 16px;
          font-weight: 600;
        }
       .el-dialog__headerbtn .el-dialog__close {
        color: rgba(0, 0, 0, 0.90);
          font-size: 16px;
          font-weight: 600;
        }
      }
        .collapse_item_work {
            margin-bottom: 4px;
            border-radius: 2px;
          }
          .el-collapse {
            margin-top: 15px;
            border: 0;
            .el-collapse-item__header {
              height: 40px;
              line-height: 48px;
              font-size: 14px;
              font-weight: 600;
              border-radius: 2px;
              background: #F4F5F6;
              padding-left: 16px;
              border: 0;
              .title_cont_work {
                display: inline-block;
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .is_finish_work {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 14px;
                height: 14px;
              }
            }
            .el-collapse-item__wrap {
              border: 0;
            }
            .el-collapse-item__content {
              padding-bottom: 24px;
              .cont_work {
                padding: 0 16px;
                .task,.tasks,.material {
                  p {
                    height: 28px;
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.40);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  }
                  ul {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 24px;
                    row-gap: 16px;
                    margin-bottom: 5px;;
                    padding: 5px 0px;
                    box-sizing: border-box;
                    border-bottom: 0.5px solid #D7E2FD;
                    cursor: pointer;
                    li {
                      position: relative;
                      width: 32px;
                      height: 32px;
                      background: #F4F5F6;
                      text-align: center;
                      line-height: 32px;
                      cursor: pointer;
                    }
                    li.active {
                      line-height: 30px;
                      font-weight: 600;

                    }

                  }
                }
                .task,.tasks {
                  ul {
                    li {
                      border-radius: 20px;
                    }
                  }
                }
                .task {
                  padding-bottom: 24px;
                }
                .material {
                  ul {
                    li {
                      border-radius: 4px;
                    }
                  }
                }
              }
            }
          }

 }

    /*.feedBack {*/
    /*  .el-dialog__header {*/
    /*    background: #5397F7;*/
    /*    border-radius: 8px 8px 0px 0px;*/

    /*    span {*/
    /*      color: #fff;*/
    /*      font-size: 14px;*/
    /*    }*/

    /*    .el-dialog__headerbtn .el-dialog__close {*/
    /*      color: #fff;*/
    /*    }*/
    /*  }*/

    /*  .from_cont {*/
    /*    .el-form-item__content {*/
    /*      margin-left: 10px !important;*/

    /*      .myQuillEditor {*/
    /*        display: block;*/
    /*      }*/
    /*    }*/
    /*  }*/

    /*  .close_cont {*/
    /*    display: flex;*/
    /*    justify-content: center;*/
    /*    padding: 20px 0;*/

    /*    img {*/
    /*      display: inline-block;*/
    /*      width: 72px;*/
    /*      height: 72px;*/
    /*      margin-right: 24px;*/
    /*    }*/

    /*    .title {*/
    /*      display: flex;*/
    /*      flex-direction: column;*/
    /*      justify-content: space-between;*/

    /*      p {*/
    /*        &:first-child {*/
    /*          color: #34D3B0;*/
    /*          font-size: 32px;*/
    /*          font-weight: bold;*/
    /*        }*/

    /*        &:last-child {*/
    /*          color: #333333;*/
    /*          font-size: 16px;*/
    /*        }*/
    /*      }*/
    /*    }*/
    /*  }*/
    /*}*/
  }

  .layui-layer {
    overflow: hidden;
    border-radius: 5px;
  }

  .layui-layer-content {
    width: 100%;
    height: 98% !important;
    padding-bottom: 20px;
  }

  .layui-layer-title {
    height: 30px;
    line-height: 30px;
  }

  .layui-layer-setwin {
    top: 10px;
  }

  .contain_height {
    height: 100%;
  }



  /*.count_down_dialog {*/
  /*  !*position: fixed;*!*/
  /*  !*width: 100%;*!*/
  /*  !*height: 100%;*!*/
  /*  .el-dialog {*/
  /*    !*position: fixed !important;*!*/
  /*    !*width: 290px !important;*!*/
  /*    pointer-events: auto !important;*/
  /*    !*height: 200px !important;*!*/
  /*    !*left: 0 !important;*!*/
  /*    !*right: 0 !important;*!*/
  /*    !*margin: 15vh auto !important;*!*/
  /*  }*/

  /*  .el-dialog__header {*/
  /*    width: 100%;*/
  /*    height: 48px;*/
  /*    background: rgba(237, 244, 255, 1);*/
  /*    padding: 20px 15px 0 15px;*/
  /*    box-sizing: border-box;*/
  /*    border-radius: 8px 8px 0 0;*/

  /*    span {*/
  /*      display: block;*/
  /*      font-size: 14px;*/
  /*      font-weight: 400;*/
  /*      color: rgba(83, 151, 247, 1);*/
  /*      border-left: 2px solid #5397F7;*/
  /*      line-height: 10px;*/
  /*      padding-left: 5px;*/
  /*    }*/

  /*    .el-dialog__headerbtn {*/
  /*      top: 18px;*/
  /*    }*/
  /*  }*/

  /*  .count_down_main {*/
  /*    p {*/
  /*      text-align: center;*/
  /*      margin-top: 16px;*/

  /*      &:first-child {*/
  /*        font-size: 16px;*/
  /*      }*/

  /*      &:last-child {*/
  /*        font-size: 14px;*/
  /*        margin-bottom: 16px;*/

  /*        span {*/
  /*          color: #DB3737;*/
  /*        }*/
  /*      }*/
  /*    }*/
  /*  }*/
  /*}*/

  .lock_box {
    margin: 16px;
    width: calc(100% - 32px);
    height: calc(100% - 32px);
    background: white;
    text-align: center;

    img {
      width: 280px;
      margin-top: 80px;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      // color:rgba(153,153,153,1);
      margin-top: 16px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/courseware/training2Index.vue